"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _SideNavigationBase = _interopRequireDefault(require("../SideNavigationBase"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const SideNavigationLink = _ref => {
  let {
    component,
    ...props
  } = _ref;
  let className = null;
  if ("className" in props && typeof props.className === "string") {
    className = props.className;
    delete props.className;
  }
  return /*#__PURE__*/_react.default.createElement(_SideNavigationBase.default, _extends({
    className: (0, _classnames.default)("p-side-navigation__link", className),
    component: component !== null && component !== void 0 ? component : "a"
  }, props));
};
var _default = exports.default = SideNavigationLink;